import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import noop from 'lodash/noop';
import Dropdown from '../Dropdown';

export default class HubsSelectField extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    field: PropTypes.shape({
      value: PropTypes.string,
      getAllowedValues: PropTypes.func,
      setValue: PropTypes.func,
    }),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    initialValue: PropTypes.string,
  };

  static defaultProps = {
    onChange: noop,
    initialValue: '',
  };

  onChange = (event, { value }) => {
    const setValue = get(this, 'props.field.setValue', noop);
    setValue(value);
    this.props.onChange(event, { value });
  }

  render() {
    const { name, placeholder, id, field, initialValue, ...rest } = this.props;
    const getAllowedValues = get(field, 'getAllowedValues', noop);
    const values = getAllowedValues() || [];
    const options = values.map((option) => ({ value: option.id, text: option.label }));

    return (
      <Dropdown
        id={id}
        value={initialValue}
        placeholder={placeholder || name}
        options={options}
        data-cy="Premium-Hem-HubsSelectField"
        onChange={this.onChange}
        {...rest}
      />
    );
  }
}
